import React, { useState } from "react";
import Blogbubble from "../components/Blog/Blogbubble";
import {
  EyesViewIcon,
  RepliesIcon,
  DateIcon,
  UserIcon,
  FireTrending,
} from "../assets/svg/svgForums";
export default function Blog() {
  // Dữ liệu giả cho danh sách blog
  const blogs = [
    {
      id: 1,
      title: "[HN] Ngân sách max 60tr, cần build máy train AI, card 3090Ti",
      views: 100,
      replies: 50,
      date: "2023-10-01",
      description:
        "Gom được 60tr, nhờ các bác tư vấn hộ cấu hình chỉ để train AI, CPU em cần là 3090Ti chứ lên nữa ko đủ lúa, CPU AM5+Main dòng X của AMD. Thanks các bác!",
    },
    {
      id: 2,
      title:
        "Nhờ các bác tư vấn cấu hình <20 triệu build pc phục vụ lập trình web, android là chính",
      views: 100,
      replies: 50,
      date: "2023-10-01",
      description:
        "Nếu bạn đang ở nước ngoài, chúng tôi đang thử nghiệm chức năng xác thực tự động, nếu bạn đang ở nước ngoài và vẫn chưa thấy tài khoản của mình là Senior Member, hãy post bài tại mục Góp Ý để nhận được giúp đỡ. Nếu bạn đang ở nước ngoài, chúng tôi đang thử nghiệm chức năng xác thực tự động, nếu bạn đang ở nước ngoài và vẫn chưa thấy tài khoản của mình là Senior Member, hãy post bài tại mục Góp Ý để nhận được giúp đỡ.",
    },
    {
      id: 3,
      title:
        " [CLB Chứng khoán] Chia sẻ kinh nghiệm đầu tư chứng khoán 2025 - Vì mục tiêu tăng trưởng 20%/năm",
      views: 100,
      replies: 50,
      date: "2023-10-01",
      description:
        "Qua năm 2025, mình lập thớt chứng khoán mới để anh em tụ họp chia sẻ kinh nghiệm với 1 năm 2024 đầy biến động. Vn Index cứ side 11xx tới 13xx. Vì mục tiêu 20%/ năm cho năm 2025.",
      image: "https://example.com/image3.jpg",
    },
    {
      id: 4,
      title:
        "Arsenal FC Official VOZe: Arteta & The final Season Netflix 2024/2025",
      description:
        "Altino nhiều thiên tài mà! Bí mật gì cũng biết, trên thông thiên văn, dưới tường địa lý, chỉ tỉ phú cách kinh doanh, dạy tổng thống cách làm chính trị, thậm chí còn đưa ra lời khuyên cho các quốc gia giàu nhất nhì thế giới cách làm sao để phát triển đất nước.",
      views: 100,
      replies: 50,
      date: "2023-10-01",
    },
    {
      id: 5,
      title:
        "Arsenal FC Official VOZe: Arteta & The final Season Netflix 2024/2025",
      description:
        "Altino nhiều thiên tài mà! Bí mật gì cũng biết, trên thông thiên văn, dưới tường địa lý, chỉ tỉ phú cách kinh doanh, dạy tổng thống cách làm chính trị, thậm chí còn đưa ra lời khuyên cho các quốc gia giàu nhất nhì thế giới cách làm sao để phát triển đất nước.",
      views: 100,
      replies: 50,
      date: "2023-10-01",
    },
    {
      id: 6,
      title:
        "Arsenal FC Official VOZe: Arteta & The final Season Netflix 2024/2025",
      description:
        "Altino nhiều thiên tài mà! Bí mật gì cũng biết, trên thông thiên văn, dưới tường địa lý, chỉ tỉ phú cách kinh doanh, dạy tổng thống cách làm chính trị, thậm chí còn đưa ra lời khuyên cho các quốc gia giàu nhất nhì thế giới cách làm sao để phát triển đất nước.",
      views: 100,
      replies: 50,
      date: "2023-10-01",
    },
    {
      id: 7,
      title:
        "Arsenal FC Official VOZe: Arteta & The final Season Netflix 2024/2025",
      description:
        "Altino nhiều thiên tài mà! Bí mật gì cũng biết, trên thông thiên văn, dưới tường địa lý, chỉ tỉ phú cách kinh doanh, dạy tổng thống cách làm chính trị, thậm chí còn đưa ra lời khuyên cho các quốc gia giàu nhất nhì thế giới cách làm sao để phát triển đất nước.",
      views: 100,
      replies: 50,
      date: "2023-10-01",
    },
    {
      id: 8,
      title:
        "Arsenal FC Official VOZe: Arteta & The final Season Netflix 2024/2025",
      description:
        "Altino nhiều thiên tài mà! Bí mật gì cũng biết, trên thông thiên văn, dưới tường địa lý, chỉ tỉ phú cách kinh doanh, dạy tổng thống cách làm chính trị, thậm chí còn đưa ra lời khuyên cho các quốc gia giàu nhất nhì thế giới cách làm sao để phát triển đất nước.",
      views: 100,
      replies: 50,
      date: "2023-10-01",
    },
    {
      id: 9,
      title:
        "Arsenal FC Official VOZe: Arteta & The final Season Netflix 2024/2025",
      description:
        "Altino nhiều thiên tài mà! Bí mật gì cũng biết, trên thông thiên văn, dưới tường địa lý, chỉ tỉ phú cách kinh doanh, dạy tổng thống cách làm chính trị, thậm chí còn đưa ra lời khuyên cho các quốc gia giàu nhất nhì thế giới cách làm sao để phát triển đất nước.",
      views: 100,
      replies: 50,
      date: "2023-10-01",
    },
    {
      id: 10,
      title:
        "Arsenal FC Official VOZe: Arteta & The final Season Netflix 2024/2025",
      description:
        "Altino nhiều thiên tài mà! Bí mật gì cũng biết, trên thông thiên văn, dưới tường địa lý, chỉ tỉ phú cách kinh doanh, dạy tổng thống cách làm chính trị, thậm chí còn đưa ra lời khuyên cho các quốc gia giàu nhất nhì thế giới cách làm sao để phát triển đất nước.",
      views: 100,
      replies: 50,
      date: "2023-10-01",
    },
  ];

  const blog2 = [
    {
      id: 1,
      title: "[HN] Ngân sách max 60tr, cần build máy train AI, card 3090Ti",
      views: 100,
      replies: 50,
      date: "2023-10-01",
      description:
        "Gom được 60tr, nhờ các bác tư vấn hộ cấu hình chỉ để train AI, CPU em cần là 3090Ti chứ lên nữa ko đủ lúa, CPU AM5+Main dòng X của AMD. Thanks các bác!",
    },
    {
      id: 2,
      title:
        "Nhờ các bác tư vấn cấu hình <20 triệu build pc phục vụ lập trình web, android là chính",
      views: 100,
      replies: 50,
      date: "2023-10-01",
      description:
        "Nếu bạn đang ở nước ngoài, chúng tôi đang thử nghiệm chức năng xác thực tự động, nếu bạn đang ở nước ngoài và vẫn chưa thấy tài khoản của mình là Senior Member, hãy post bài tại mục Góp Ý để nhận được giúp đỡ. Nếu bạn đang ở nước ngoài, chúng tôi đang thử nghiệm chức năng xác thực tự động, nếu bạn đang ở nước ngoài và vẫn chưa thấy tài khoản của mình là Senior Member, hãy post bài tại mục Góp Ý để nhận được giúp đỡ.",
    },
    {
      id: 3,
      title:
        " [CLB Chứng khoán] Chia sẻ kinh nghiệm đầu tư chứng khoán 2025 - Vì mục tiêu tăng trưởng 20%/năm",
      views: 100,
      replies: 50,
      date: "2023-10-01",
      description:
        "Qua năm 2025, mình lập thớt chứng khoán mới để anh em tụ họp chia sẻ kinh nghiệm với 1 năm 2024 đầy biến động. Vn Index cứ side 11xx tới 13xx. Vì mục tiêu 20%/ năm cho năm 2025.",
      image: "https://example.com/image3.jpg",
    },
    {
      id: 4,
      title:
        "Arsenal FC Official VOZe: Arteta & The final Season Netflix 2024/2025",
      description:
        "Altino nhiều thiên tài mà! Bí mật gì cũng biết, trên thông thiên văn, dưới tường địa lý, chỉ tỉ phú cách kinh doanh, dạy tổng thống cách làm chính trị, thậm chí còn đưa ra lời khuyên cho các quốc gia giàu nhất nhì thế giới cách làm sao để phát triển đất nước.",
      views: 100,
      replies: 50,
      date: "2023-10-01",
    },
    {
      id: 5,
      title:
        "Arsenal FC Official VOZe: Arteta & The final Season Netflix 2024/2025",
      description:
        "Altino nhiều thiên tài mà! Bí mật gì cũng biết, trên thông thiên văn, dưới tường địa lý, chỉ tỉ phú cách kinh doanh, dạy tổng thống cách làm chính trị, thậm chí còn đưa ra lời khuyên cho các quốc gia giàu nhất nhì thế giới cách làm sao để phát triển đất nước.",
      views: 100,
      replies: 50,
      date: "2023-10-01",
    },
  ];

  // Trạng thái
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const blogsPerPage = 6;

  // Tìm kiếm blog
  const filteredBlogs = blogs.filter((blog) =>
    blog.title.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Tính toán các blog trên trang hiện tại
  const indexOfLastBlog = currentPage * blogsPerPage;
  const indexOfFirstBlog = indexOfLastBlog - blogsPerPage;
  const currentBlogs = filteredBlogs.slice(indexOfFirstBlog, indexOfLastBlog);
  // Chuyển trang
  const nextPage = () => {
    if (currentPage < Math.ceil(filteredBlogs.length / blogsPerPage)) {
      setCurrentPage(currentPage + 1);
      window.scrollTo(0, 0); // Scrolls to the top instantly
    }
  };

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
      window.scrollTo(0, 0); // Scrolls to the top instantly
    }
  };

  return (
    <div className="relative flex flex-col items-center justify-center w-[100vw] h-auto bg-black/95 pt-[60px] pb-[60px] overflow-hidden">
      {/* Cyberpunk grid background */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: `
            linear-gradient(cyan 1px, transparent 1px),
            linear-gradient(90deg, cyan 1px, transparent 1px)
          `,
          backgroundSize: '50px 50px'
        }}></div>
      </div>
      
      {/* Decorative elements */}
      <div className="absolute -top-20 -left-20 w-80 h-80 bg-gradient-to-br from-cyan-400/10 to-pink-400/10 rounded-full blur-3xl"></div>
      <div className="absolute -bottom-20 -right-20 w-80 h-80 bg-gradient-to-br from-green-400/10 to-purple-400/10 rounded-full blur-3xl"></div>
      
      <div className="w-[90%] pt-4 relative z-10">
        <div className="flex justify-between items-center mb-6 w-[100%] gap-5 max-sm:flex-col max-sm:items-end">
          <Blogbubble />
          <div className="text-center">
            <h1 className="text-2xl font-black font-mono text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-pink-500 to-green-400 animate-gradient-x tracking-wider select-none">
              [CHIBA_FORUMS]
            </h1>
            <p className="text-gray-400 text-sm font-mono mt-1">
              <span className="text-cyan-400">{'>'}</span> AI Neural Network Community
            </p>
          </div>
          {/* Search */}
          <div className="flex justify-center w-[30%] max-sm:w-[100%]">
            <div className="relative w-full">
              <input
                type="text"
                placeholder="[SEARCH_QUERY]..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full px-4 py-3 bg-black/60 border border-cyan-400/50 rounded-xl text-cyan-100 placeholder-gray-500 font-mono text-sm focus:outline-none focus:border-cyan-400 focus:shadow-neon-cyan transition-all duration-300 backdrop-blur-sm"
              />
              <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
                <svg className="w-4 h-4 text-cyan-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
              </div>
            </div>
          </div>
        </div>

        {/* Blog Grid */}
        <div className="flex flex-row max-md:flex-col justify-between gap-6">
          <div className="flex flex-col w-[68%] gap-4 mt-3 max-md:w-[100%]">
            {currentBlogs.map((blog) => (
              <div
                key={blog.id}
                className="group relative bg-black/60 border border-cyan-400/30 rounded-2xl p-6 shadow-neon-cyan hover:shadow-neon-cyan-intense transition-all duration-300 h-[fit-content] cursor-pointer backdrop-blur-sm hover:-translate-y-1 overflow-hidden"
              >
                {/* Decorative border animation */}
                <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-cyan-400 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                
                <h2 className="text-lg font-bold font-mono text-cyan-100 mb-3 group-hover:text-cyan-300 transition-colors duration-300 max-sm:text-[1rem]">
                  <span className="text-cyan-400">{'>'}</span> {blog.title}
                </h2>
                <p className="text-sm text-gray-300 transition-colors duration-300 ease-in-out group-hover:text-gray-200 line-clamp-3 font-mono leading-relaxed">
                  {blog.description}
                </p>
                <div className="flex flex-row justify-between items-center mt-4 max-sm:flex-col-reverse max-sm:items-start max-sm:gap-2">
                  <div className="flex flex-row gap-6">
                    {/* view */}
                    <div className="flex flex-row items-center gap-2 text-gray-400 font-mono text-xs">
                      <EyesViewIcon className="w-4 h-4 fill-green-400" />
                      <span className="text-green-400">{blog.views}</span>
                    </div>
                    {/* comment */}
                    <div className="flex flex-row items-center gap-2 text-gray-400 font-mono text-xs">
                      <RepliesIcon className="w-4 h-4 fill-pink-400" />
                      <span className="text-pink-400">{blog.replies}</span>
                    </div>
                    <div className="flex flex-row items-center gap-2 text-gray-400 font-mono text-xs">
                      <DateIcon className="w-4 h-4 fill-purple-400" />
                      <span className="text-purple-400">{blog.date}</span>
                    </div>
                  </div>
                  <div className="flex flex-row items-center gap-2 text-gray-400 font-mono text-xs">
                    <UserIcon className="w-4 h-4 fill-cyan-400" />
                    <span className="text-cyan-400">[CHIBA_ADMIN]</span>
                  </div>
                </div>
              </div>
            ))}
            <div className="flex justify-between mt-8">
              <button
                onClick={prevPage}
                disabled={currentPage === 1}
                className={`group relative px-6 py-3 bg-black/60 border border-cyan-400/50 text-cyan-300 rounded-xl font-mono font-medium transition-all duration-300 transform backdrop-blur-sm ${
                  currentPage === 1
                    ? "opacity-50 cursor-not-allowed"
                    : "hover:text-cyan-100 hover:shadow-neon-cyan hover:scale-105"
                }`}
              >
                <svg className="w-4 h-4 inline mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                </svg>
                [PREVIOUS]
                <div className="absolute inset-0 border border-cyan-400/30 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 animate-border-pulse"></div>
              </button>
              <div className="flex items-center gap-2 px-4 py-2 bg-black/40 border border-gray-600/50 rounded-xl font-mono text-gray-400 text-sm">
                <span className="text-cyan-400">[PAGE]</span>
                <span className="text-cyan-100">{currentPage}</span>
                <span className="text-gray-500">/</span>
                <span className="text-gray-300">{Math.ceil(filteredBlogs.length / blogsPerPage)}</span>
              </div>
              <button
                onClick={nextPage}
                disabled={
                  currentPage === Math.ceil(filteredBlogs.length / blogsPerPage)
                }
                className={`group relative px-6 py-3 bg-black/60 border border-cyan-400/50 text-cyan-300 rounded-xl font-mono font-medium transition-all duration-300 transform backdrop-blur-sm ${
                  currentPage === Math.ceil(filteredBlogs.length / blogsPerPage)
                    ? "opacity-50 cursor-not-allowed"
                    : "hover:text-cyan-100 hover:shadow-neon-cyan hover:scale-105"
                }`}
              >
                [NEXT]
                <svg className="w-4 h-4 inline ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
                <div className="absolute inset-0 border border-cyan-400/30 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 animate-border-pulse"></div>
              </button>
            </div>
          </div>
          <div className="flex flex-col w-[30%] h-[fit-content] mt-3 max-md:w-[100%] bg-black/60 border border-pink-400/50 rounded-2xl shadow-neon-pink backdrop-blur-sm overflow-hidden">
            <div className="relative">
              <div className="text-lg font-bold font-mono text-pink-400 flex flex-row items-center gap-3 p-4 bg-black/40">
                <div className="w-8 h-8 bg-black/60 border border-pink-400/50 rounded-lg flex items-center justify-center">
                  <FireTrending className="w-4 h-4 fill-pink-400" />
                </div>
                [TRENDING_NEURAL]
              </div>
            </div>
            {blog2.map((blog2) => (
              <div
                key={blog2.id}
                className="group border-t border-gray-700/50 p-4 transition-all duration-300 h-[fit-content] cursor-pointer overflow-hidden hover:bg-pink-400/5 relative"
              >
                <div className="absolute left-0 top-0 w-1 h-0 bg-pink-400 group-hover:h-full transition-all duration-300"></div>
                <h2 className="text-sm font-semibold font-mono text-gray-300 mb-2 group-hover:text-pink-300 transition-colors duration-300 max-sm:text-[0.9rem] pl-2">
                  <span className="text-pink-400 text-xs">{'>'}</span> {blog2.title}
                </h2>
                <p className="text-xs text-gray-500 transition-colors duration-300 ease-in-out group-hover:text-gray-400 line-clamp-3 no-underline font-mono leading-relaxed pl-2">
                  {blog2.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
